import styled from "@emotion/styled";
import { Box } from "@mui/material";
import {
  primary_color,
  primary_dark_color,
} from "../../constants/color_constants";

export const Text = styled.p`
  font-size: 1.2rem;
  font-family: "MontserratMed";
  color: ${({ theme }) => theme.palette.text.primary};
  text-align: center;
  margin: 1rem;
`;

export const TitleText = styled.p`
  font-size: 2rem;
  font-family: "MontserratMed";
  color: ${({ theme }) => theme.palette.text.primary};
  text-align: center;
  margin: 1rem;
`;

export const ModalBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 650px;
  max-width: 90vw;
  max-height: 90vh;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 16px;
  box-shadow: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? "0 8px 32px rgba(0, 0, 0, 0.6)"
      : "0 8px 32px rgba(0, 0, 0, 0.15)"};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  padding: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const ModalInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 40px;
  padding-top: 25px;
  flex: 1;
  overflow-y: auto;
`;

export const OptionCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 30px;
  border: 4px solid ${primary_color};
  box-shadow: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? "0 4px 16px rgba(0, 0, 0, 0.4)"
      : "0 4px 16px rgba(0, 0, 0, 0.1)"};
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: 20px;
  margin: 20px;
  width: 25vw;
`;

export const FootnoteDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 25vw;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: 20px;
  margin-right: 20px;
`;

export const ThemedTitleText = styled.p`
  font-size: 1.7rem;
  font-family: "MontserratBold";
  color: ${primary_color};
  text-align: center;
  margin: 1rem;
  /* border-bottom: 2px solid ${primary_color}; */
`;

export const HorizontalDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
`;

export const DescriptiveText = styled.p`
  font-size: 1.2rem;
  font-family: "MontserratMed";
  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: left;
  margin: 0.5rem;
  margin-top: 0;
`;

export const ActionButton = styled.div`
  border: 2px solid ${primary_color};
  background-color: ${primary_color};
  border-radius: 12px;
  cursor: pointer;
`;

export const ActionButtonText = styled.p`
  font-size: 1.2rem;
  font-family: "MontserratBold";
  color: black;
  background-color: ${primary_color};
  text-align: left;
  margin: 0.4rem;
  margin-left: 0.8rem;
  margin-right: 0.8rem;
`;
